import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=0cfa5a80&scoped=true&"
import script from "./mall.vue?vue&type=script&lang=js&"
export * from "./mall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa5a80",
  null
  
)

export default component.exports